export default "__VITE_ASSET__80a29cf3__"